import React from "react";
import { Box, makeStyles, withStyles } from "@material-ui/core";
import LinearProgress from '@material-ui/core/LinearProgress';

const style = makeStyles((theme) => ({
    progressBox: (props) => ({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '10px 0',
        cursor: props.options.tabela.length ? 'pointer' : 'initial',
        "& h3": {
            fontSize: '14px',
            margin: '0 0 5px 0'
        },
        '& p': {
            margin: '0 0 5px 0',
        },
        "& .progress-bar": {
            flexBasis: '100%'
        },
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: props.options.cor
        },
        '&:hover': {
            color: props.options.tabela.length ? '#577883' : '#333'
        }
    })
}));

const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#1a90ff',
    },
  }))(LinearProgress);

const progressValue = (value, total) => {
    if(!total) return 0;
    return parseFloat(((value / total) * 100).toFixed(2));
}

const ProgressBar = (props) => {
    const classes = style(props);
    const tabela = props.options.tabela || [];
    const percentage = progressValue(props.options.tabela.length, props.total);
    const mostrarTabela = () => {
        if (props.options.exibeModal && tabela.length) {
            props.options.setTabelaAtual(tabela);
            props.options.abrirModal();
            props.options.setNomeTabela(props.options.texto || "");
        }
    }
    return(
        <Box className={classes.progressBox} onClick={() => mostrarTabela()}>
            <h3>{props.options.texto}</h3>
            <p>{percentage}%</p>
            <BorderLinearProgress className="progress-bar" variant="determinate" value={percentage} />
        </Box>
    )
}

export default ProgressBar;